import Controller from "keno/app/controllers/Controller";
import KenoCardView from "keno/app/views/KenoCard";
import PlayService, { PlayRequest } from "keno/app/services/Play";
import GameService from "keno/app/services/Game";
import Cookies from "js-cookie";
import { globalDisplayQueue } from "keno/app/modules/DisplayQueue";

const STORE_COOKIE_NAME = `keno-gamestore`;

/**
 * This controller handles a playable Keno Card
 * It creates a corresponding KenoCard view which it receives
 * the user events for selecting numbers and submitting the card
 */
class KenoCardController extends Controller {
	constructor(appModel, view = new KenoCardView()) {
		super(appModel, view);
		this.playService = new PlayService();
		this.gameService = new GameService();
	}

	init() {
		this.view.init(this.appModel);
		this.view.addEvent(
			this.view.EVENTS.SUBMIT,
			this.handleCardSubmit.bind(this)
		);
		this.view.addEvent(
			this.view.EVENTS.GLITCH_SUBMIT,
			this.handleGlitchSubmit.bind(this)
		);
		this.view.addEvent(
			this.view.EVENTS.CHOICE_SELECT,
			this.handleGameChoiceSelect.bind(this)
		);
		this.view.addEvent(
			this.view.EVENTS.UPDATE_USER_NUMBERS,
			this.handleUpdateUserNumbers.bind(this)
		);
		this.view.addEvent(
			this.view.EVENTS.SSO_LIGHTBOX_SUBMIT,
			this.handleSSOLightBoxSubmit.bind(this)
		);
	}

	route(ctx, next) {
		super.route(ctx, next);
		this.checkUnrecognizedSubmission();
	}

	/**
	 * Will look for the cookie set when an unrecognized user submitted the card
	 * and has returned once signed in. If this is the case, request will be made to
	 * the api to submit their prior submission
	 */
	checkUnrecognizedSubmission() {
		if (window.unRecognizedUserGamePlay) {
			const submitCookie = JSON.parse(Cookies.get(STORE_COOKIE_NAME));

			if (!this.submitPending) {
				this.handleCardSubmit(
					this.view.getGameTimestampId(),
					submitCookie.card_number,
					(submitCookie.numbers || ``).split(`,`)
				);
			}
		}
	}
	/**
	 * gets user played games (if any) and calls the view to update with those numbers
	 */
	handleUpdateUserNumbers() {
		if (window.KENO_GLOBALS.USER_GAME_PLAYS) {
			// var values = Object.keys(obj).map(e => obj[e]);

			window.KENO_GLOBALS.USER_GAME_PLAYS = Object.keys(
				window.KENO_GLOBALS.USER_GAME_PLAYS
			).map(e => window.KENO_GLOBALS.USER_GAME_PLAYS[e]);

			// window.KENO_GLOBALS.USER_GAME_PLAYS = Object.values(
			//   window.KENO_GLOBALS.USER_GAME_PLAYS
			// );
		}

		this.view.updateUserNumbersHTML(window.KENO_GLOBALS.USER_GAME_PLAYS);
		//console.log('controller: handleUpdateUserNumbers called...');

		// if (this.appModel._data.completedCardNumber > 0) {
		//   this.gameService.gamesPlayed(
		//     this.appModel.gameTimestampId,
		//     (err, resp) => {
		//       if (err) {
		//         return;
		//       }
		//       this.appModel._data.completedGames = resp.games;
		//       this.view.updateUserNumbersHTML(resp.games);
		//     }
		//   );
		// } else {
		//   this.appModel._data.completedGames = [];
		// }
	}
	/**
	 * handles submit from sso lightbox, lets appModel know user is fully registered and then submits numbers
	 * @param {string} gameInstanceId - current game id
	 * @param {int} cardNum - current card number
	 * @param {array} selectedNumbers - user selected numbers
	 *
	 */
	handleSSOLightBoxSubmit(gameInstanceId, cardNum, selectedNumbers) {
		this.appModel._data.currentUser.isFullyRegistered = true;
		this.handleCardSubmit(gameInstanceId, cardNum, selectedNumbers);
	}
	/**
	 * handles submit from game card, shows sso lightbox for no password user,  handles submit for recognized and unrecognized user
	 * @param {string} gameInstanceId - current game id
	 * @param {int} cardNum - current card number
	 * @param {array} selectedNumbers - user selected numbers
	 *
	 */
	handleCardSubmit(gameInstanceId, cardNum, selectedNumbers) {
		if (cardNum === 1) {
			sessionStorage.removeItem(`pathStarted`, true);
			sessionStorage.setItem(`gameCompletedTriggerOnce`, false);
		}
		if (
			this.appModel._data.currentUser &&
			!this.appModel._data.currentUser.isFullyRegistered &&
			this.appModel._data.currentUser.isRecognizedUser &&
			!this.appModel._data.currentUser.isMiniReg &&
			!this.appModel._data.currentUser.isSocialReg
		) {
			//no password user, show lightbox
			this.view.showCreatePasswordLightbox();
		} else {
			this.view.disableSubmit();
			this.submitPending = true;

			this.handleCardSubmitRecognized(gameInstanceId, cardNum, selectedNumbers);
		}
	}

	/**
	 *calls api submit for recognized user
	 * @param {*} gameInstanceId
	 * @param {*} cardNum
	 * @param {*} selectedNumbers
	 *
	 */
	handleCardSubmitRecognized(gameInstanceId, cardNum, selectedNumbers) {
		this.playService.play(
			gameInstanceId,
			cardNum,
			selectedNumbers,
			this.handlePlaySubmitResponse.bind(this)
		);
	}
	/**
	 *handles response back from the api on gameplay submit, displays errors, handles contest entries
	 * @param {json} err - error response json
	 * @param {json} resp - success api response
	 *
	 */
	handlePlaySubmitResponse(err, resp) {
		if (err) {
			if (err.body.status === `duplicated`) {
				this.view.onDuplicateNumbers(err.body.message);
				this.view.onClear();
				this.view.enableSubmit();
			} else if (err.body.status === `timeout`) {
				this.showTimeoutError();
			} else {
				this.showTechnicalDifficulties();
				this.view.enableSubmit();
			}
		} else {
			// update uninav status
			//this.appModel.globalDisplayQueue.enqueue(() => {
			this.view.eventTracker(`Complete`);

			this.appModel.uninav.fetchAndUpdateTokenBalanceDisplay();
			//return this.appModel.uninav.onIdle();
			//});
			//
			if (resp) {
				this.handleContestEntry(resp);
				//this.appModel.globalDisplayQueue.addEmptiedCallback(() => {
			} else {
				// we shouldnt get here, but what should we do in the event that the next url isnt returned?
				//this.appModel.globalDisplayQueue.addEmptiedCallback(() => {
				this.appModel.uninav.onIdle().then(() => {
					this.refreshPage();
				});
			}
		}

		this.submitPending = false;
		if (!this.isActive) {
			// user has since been navigated to another page
			return;
		}
	}
	/**
	 *
	 * @param {boolean} showLastActivity - show last activity in feedback module
	 * refreshes page
	 */
	refreshPage(showLastActivity = false) {
		PCH.uninav?.controller?.vip?.clearCachedStatusWithoutActivity(); // ensure on next page load new status is fetched, not from cache
		window.location.reload();
		if (showLastActivity) {
			sessionStorage.setItem(`showLastActivity`, `true`);
		}
	}
	/**
	 *handles contest entry response from api, shows sweepstakes entry confirmed, shows first card bonus entry , shows event Contest Entry
	 * @param {json} resp - game submission response from api
	 *
	 */
	handleContestEntry(resp) {
		// Keeping else statement here for testing until story is finished
		if (resp.body.sweepstake) {
			const data = resp.body;

			if (data.sweepstake.success) {
				this.appModel._data.GLOBALS.KENO.CONTEST_ENTRIES.enableSweepsBanner = false;
				if (!data.sweepstake.toastImage || data.sweepstake.toastImage === ``) {
					this.view.showSweepstakesEntryConfirmed(data);
				}
				if (data.sweepstake.tokensAmount !== 0) {
					this.appModel.uninav.showTokensMessage(
						data.sweepstake.tokensAmount,
						data.sweepstake.tokensMessage
					);
				}
			} else if (data.firstCardBonus) {
				if (data.firstCardBonus.success) {
					this.appModel.uninav.showTokensMessage(
						data.firstCardBonus.tokens,
						data.firstCardBonus.description
					);
				}
			}

			if (data.sweepstake.success) {
				if (data.sweepstake.toastImage) {
					globalDisplayQueue.enqueue(
						this.view.showPromotionEntryConfirmed.bind(
							this,
							data.sweepstake.toastImage,
							data.sweepstake.contestMessage
						)
					);

					// this.view.hidePromotionEntryBanner();
					globalDisplayQueue.addEmptiedCallback(() => {
						this.refreshPage();
					}); //refresh page after promotion entry confirmed
				} else {
					this.appModel.uninav.onIdle().then(() => {
						this.refreshPage(); //refresh when uni-nav messages are down showing
					});
				}
			} else {
				this.appModel.uninav.onIdle().then(() => {
					this.refreshPage(); //refresh when uni-nav messages are down showing
				});
			}
		} else {
			this.appModel.uninav.onIdle().then(() => {
				this.refreshPage(); //refresh when uni-nav messages are down showing
			});
		}
	}
	/**
	 * handle card submit for unrecognized user, submits numbers and navigates user to registration
	 * @param {*} gameInstanceId
	 * @param {*} cardNum
	 * @param {*} selectedNumbers
	 *
	 */
	handleCardSubmitUnrecognized(gameInstanceId, cardNum, selectedNumbers) {
		const req = new PlayRequest(gameInstanceId, cardNum, selectedNumbers);

		Cookies.set(STORE_COOKIE_NAME, req.serializedBody);
		this.navigateToRegistration();
	}
	/**
	 * handles error on submit, currently reloads page
	 */
	handleGlitchSubmit() {
		window.location.reload();
	}
	/**
	 *send play api the id of the selected choice on choices screen
	 * @param {string} choiceId - id of selected choice from choices screen
	 *
	 */
	handleGameChoiceSelect(choiceId) {
		this.view.disableSubmit();
		this.playService.selectChoice(
			this.appModel.gameTimestampId,
			choiceId,
			this.handlePlaySubmitResponse.bind(this)
		);
	}
}

export default KenoCardController;
